//-----------------------------------------------------------------------------
// Michael B. Gale's Website
// Copyright (c) 2022 Michael B. Gale (hello@michael-gale.co.uk)
//-----------------------------------------------------------------------------

import * as React from "react";
import type { GatsbyBrowser, GatsbySSR } from "gatsby";
import Layout from "./src/components/Layout";

//-----------------------------------------------------------------------------

export const warpWithLayout: GatsbyBrowser['wrapPageElement'] & GatsbySSR['wrapPageElement'] = ({props, element}) => {
    console.log(props);
    console.log(element);
    return <Layout {...props}>{element}</Layout>;
}

export default warpWithLayout;

//-----------------------------------------------------------------------------
